import {MouseEvent} from "react"
import {connect} from "react-redux"
import logger from "@next/core-logger"
import type {AxiosError} from "axios"

import {State} from "../../ducks"

import axios from "../../utils/axios"

export const mapStateToProps = (state: State) => {
    return {
        siteUrl: state.languages.siteUrl,
        text: state.text,
        templating: state.template,
    }
}

export const mapDispatchToProps = () => {
    return {
        deviceSwitcherFn: async (event: MouseEvent<HTMLAnchorElement>, url: string) => {
            try {
                event.preventDefault()
                await axios.get(url, {
                    withCredentials: true,
                    headers: {Pragma: "no-cache"},
                })
                window.location.reload()
            } catch (error) {
                const e = error as AxiosError
                logger.error(`Copyright - unable to call ${url} - ${e}`)
                logger.error(e)
                logger.error(e.response)
            }
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)
